import { historyItemCommentWithSource as commentWithSource, pdaCommentHistoryItems, robotHistoryFieldLabel } from "../../../utils/patientHistory";

export { pdaCommentHistoryItems };

export function historyFieldLabel(fieldName) {
    if (fieldName === "pdaProductionRemark") return "Remarque production PDA";
    return robotHistoryFieldLabel(fieldName) || fieldName || "Historique";
}

export function historyItemCommentWithSource(item) {
    return commentWithSource(item, "PDA");
}
